import React from 'react';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { getSiteHeaderVariant, getTravelAgency } from '../../store/slices/user';
import { TwAttributionVariants, logoLayoutVariants } from '../../constants';
import AgencyLogo from '../AgencyLogo';
import TravelWitsLogo from '../../assets/svgs/travelwitsLogo.svg';
import HeaderVariant from '../../constants/HeaderVariant';

const AgencyLogoWithAttribution = ({ agencyLogoOverride }) => {
  const { isLoading } = useAuth0();
  const travelAgency = useSelector(getTravelAgency);
  const doShowlogoLayoutVariant =
    travelAgency &&
    travelAgency.settings &&
    travelAgency.settings.logoLayoutVariant === logoLayoutVariants.LOGO_IMAGE_TEXT_VARIANT;
  const agencyTextLogo =
    travelAgency && travelAgency.settings && travelAgency.settings.agencyTextLogo;
  const doMakeTravelwitsLogoSmaller =
    travelAgency && travelAgency.siteTheme && travelAgency.siteTheme.doMakeTravelwitsLogoSmaller;
  const doMoveAgencyLogoToFooter =
    travelAgency && travelAgency.siteTheme && travelAgency.siteTheme.doMoveAgencyLogoToFooter;
  const headerVariant = useSelector(getSiteHeaderVariant);
  const doShowWithBrandingTopBar = !isLoading && headerVariant === HeaderVariant.withBrandingTopBar;
  const twAttributionVariant =
    travelAgency && travelAgency.siteTheme && travelAgency.siteTheme.TwAttributionVariant;
  const doShowAttributionBelowAgencyLogo =
    twAttributionVariant === TwAttributionVariants.BELOW_AGENCY_LOGO;
  const doShowAttributionUnderSearchBar =
    twAttributionVariant === TwAttributionVariants.UNDER_SEARCH_BAR;

  let logoClass = 'max-h-16';
  if (doShowlogoLayoutVariant && agencyTextLogo) {
    logoClass = 'w-48 sm:w-56';
  } else if (doMakeTravelwitsLogoSmaller) {
    logoClass = 'md:max-h-20 max-h-10';
  }
  return (
    <div
      className={clsx('text-logo-0 border-white', {
        'lg:w-auto w-full': doShowWithBrandingTopBar,
        'flex col-span-3 py-3': !doShowAttributionBelowAgencyLogo,
        'flex flex-col gap-2': doShowAttributionBelowAgencyLogo,
      })}
    >
      {!doMoveAgencyLogoToFooter && (
        // oxlint-disable-next-line nextjs/no-html-link-for-pages
        <a href="/" className="self-center lg:w-auto w-full">
          <AgencyLogo
            doShowOriginalLogo
            className={logoClass}
            agencyLogoOverride={agencyLogoOverride}
          />
        </a>
      )}
      {!doShowAttributionUnderSearchBar && !doShowWithBrandingTopBar && (
        <div
          className={clsx('flex sm:h-full border-logo-0', {
            'flex-col justify-between':
              doShowlogoLayoutVariant && agencyTextLogo && !doShowAttributionBelowAgencyLogo,
            'pl-4 ml-4 border-l-2': !doShowAttributionBelowAgencyLogo && !doMoveAgencyLogoToFooter,
          })}
        >
          {doShowlogoLayoutVariant && agencyTextLogo && (
            <img src={agencyTextLogo} alt="agency text logo" className="w-40 h-6 mt-3" />
          )}
          <div
            className={clsx(
              twAttributionVariant === TwAttributionVariants.LOGO_CENTER
                ? 'self-center'
                : 'self-end',
              { 'flex items-center gap-2': doShowAttributionBelowAgencyLogo },
            )}
          >
            <div className={doMakeTravelwitsLogoSmaller ? 'text-10' : 'text-xs'}>Powered by</div>
            {/* oxlint-disable-next-line nextjs/no-html-link-for-pages */}
            <a href="/">
              <TravelWitsLogo
                fill="currentColor"
                width={doMakeTravelwitsLogoSmaller ? '90' : '130'}
                height={doMakeTravelwitsLogoSmaller ? '15' : '20'}
              />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
AgencyLogoWithAttribution.propTypes = {
  agencyLogoOverride: PropTypes.string,
};

AgencyLogoWithAttribution.defaultProps = {
  agencyLogoOverride: undefined,
};
export default AgencyLogoWithAttribution;
